module.exports = __webpack_public_path__ + "img/123-eryaxindahei-63d.cd7e811b.png";